export default __webpack_public_path__ + "static/media/web-app.06978dfa.svg";